export default __webpack_public_path__ + "static/media/SuccessTick.edffe12c.svg";